

import React from "react";
import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import LoadingOverlay from 'components/LoadingOverlay';

const PrivateRoute = ({ component, ...args }) => (
  <Route
    component={withAuthenticationRequired(component, {
      onRedirecting: () => <LoadingOverlay loading={true}/>,
    })}
    {...args}
  />
);

export default PrivateRoute;

